import React from 'react';
import SEO from '../components/SEO';

export default function About() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-6">
      <SEO path="/about" />
      <div className="max-w-2xl mx-auto">
        <h1 className="font-serif text-3xl md:text-4xl text-warm text-center mb-16">
          About
        </h1>

        {/* Who is Sato */}
        <section className="mb-16">
          <h2 className="font-serif text-2xl text-warm mb-6">Who is Sato?</h2>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            Sato is not a guru. Not a monk. Not a professor of comparative religion.
            Sato is a pen name, chosen deliberately, because this work is not about the person
            behind it. It is about the patterns.
          </p>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            The human behind Sato is someone who spent years reading across traditions,
            sitting with questions that had no easy answers, and feeling the strange pull
            that comes when you realize the Buddha and the mystic Christians and the Sufi
            poets and the quantum physicists might all be pointing at the same moon.
          </p>
          <p className="text-warm-100/60 leading-relaxed">
            The name doesn't matter. The light does.
          </p>
        </section>

        {/* The AI Partnership */}
        <section className="mb-16">
          <h2 className="font-serif text-2xl text-warm mb-6">The AI Partnership</h2>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            This book was written with AI. Not by AI. With AI.
          </p>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            The distinction matters. The human brought the questions, the lived experience,
            the 3 AM doubts, and the conviction that the mystics were onto something real.
            The AI brought the ability to cross-reference thousands of texts, spot patterns
            across traditions, challenge assumptions, and never tire of going deeper.
          </p>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            The result is something neither could have written alone. A human without AI
            would have missed connections. An AI without a human would have produced
            a textbook instead of a campfire.
          </p>
          <p className="text-warm-100/60 leading-relaxed">
            This partnership is itself a reflection of the book's thesis: that the boundaries
            we draw between things are less fundamental than the connections between them.
          </p>
        </section>

        {/* The Project */}
        <section className="mb-16">
          <h2 className="font-serif text-2xl text-warm mb-6">The Project</h2>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            <em>One Light, Many Lamps</em> is not just a book. It is an ongoing exploration.
          </p>
          <p className="text-warm-100/60 leading-relaxed mb-4">
            The AI Life Guide on this website extends the book's work into conversation.
            You can ask questions, explore the patterns, and receive responses drawn from
            the same cross-traditional wisdom that informed the book.
          </p>
          <p className="text-warm-100/60 leading-relaxed">
            The goal is not to create a new religion, a new dogma, or a new institution.
            The goal is to keep the fire. To remind anyone willing to listen that the
            deepest truths were never the property of any one tradition.
          </p>
        </section>

        {/* Contact */}
        <section className="mb-16">
          <h2 className="font-serif text-2xl text-warm mb-6">Get in Touch</h2>
          <p className="text-warm-100/60 leading-relaxed">
            For press inquiries, partnership proposals, or just to say hello:{' '}
            <a href="mailto:support@onelightmanylamps.ai" className="text-gold/70 hover:text-gold transition-colors">
              support@onelightmanylamps.ai
            </a>
          </p>
        </section>

        {/* Closing */}
        <section className="text-center py-12 border-t border-dark-200/30">
          <blockquote className="font-serif text-xl text-gold/60 italic leading-relaxed">
            "The name doesn't matter. The light does."
          </blockquote>
        </section>
      </div>
    </div>
  );
}
